import { useState } from "react";
import { reactivarAplicaciones } from "../services/facturaService";

export const useRevertirAplicaciones = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = async (IDsAplicaciones) => {
    try {
      setLoading(true);
      setError(null);

      const res = await reactivarAplicaciones(IDsAplicaciones);
      return res;
    } catch (error) {
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    execute,
    loading,
    error,
  };
};
